const contacts = [
    {
        title: "Personal Blog",
        link: "https://blog.fawazharoun.com"
    },
    {
        title: "Github",
        link: "https://github.com/Exalted100"
    },
    {
        title: "LinkedIn",
        link: "https://www.linkedin.com/in/fawaz-haroun-5b3a45178"
    },
    {
        title: "Email",
        link: "mailto:harounayomikun@gmail.com"
    },
    {
        title: "Resume",
        link: "/Fawaz-Haroun.pdf"
    }
]

export default contacts